import React, { forwardRef } from 'react';

import twoSmartphones from '../../assets/two-smartphones.png';
import template from '../../assets/template.png';
import multiDevices from '../../assets/multi-devices.png';
import Section from '../../containers/Section';
import Card from './Card/Card';

import { useInView } from 'react-intersection-observer';

const contentData = [
  {
    image: twoSmartphones,
    title: 'Product Design',
    body: 'We create UI and UX Design for webs and mobile apps to make a better look and experience.',
    extraClass: 'transition-transform duration-1000'
  },
  {
    image: template,
    title: 'Website Development',
    body: 'We develop responsive website with MERN basic technology. We can build a landing page and web apps.',
    extraClass: 'transition-transform duration-1000 delay-150'
  },
  {
    image: multiDevices,
    title: 'Android Development',
    body: 'We also develop in android apps using both react native and flutter technology.',
    extraClass: 'transition-transform duration-1000 delay-300'
  }
]

const Service = forwardRef((_, ref) => {
  const { ref: inViewRef, inView } = useInView({
    threshold: 0.4,
    triggerOnce: true
  })

  return (
    <Section innerClass="pb-10 max-w-[90%] pt-16 xl:max-w-[80%] 2xl:my-24" outerClass="overflow-x-hidden" ref={inViewRef}>
      <div className="uppercase text-xl text-center tracking-widest text-slate-700 lg:text-2xl 2xl:text-3xl pt-16" ref={ref}>Service</div>
      <div className={`flex flex-col items-center pt-16 transition-transform duration-1000 ${inView ? 'translate-x-0' : '-translate-x-full'} md:flex-row md:items-start md:translate-x-0`}>
        <div className="uppercase text-2xl text-center tracking-widest px-10 text-slate-700 font-medium md:basis-1/2 md:px-0 md:pr-10 md:text-left md:text-4xl md:leading-tight lg:text-5xl 2xl:text-8xl">We coverage mostly all for digital product development</div>
        <div className="space-y-6 mt-10 md:mt-0 md:space-y-10 md:basis-1/2" >
          {contentData.map(content => (
            <Card
              key={content.title}
              image={content.image}
              title={content.title}
              body={content.body}
              extraClass={`${content.extraClass} ${inView ? 'md:translate-x-0' : 'md:translate-x-24'}`}
            />
          ))}
        </div>
      </div>
    </Section>
  );
});

export default Service;
